import { useEffect, useState } from "react";

// BRK-S315 — the one timer behind every search as you type: `Typeahead`'s
// server searches and the list views' search box. A value counts once it has
// held still for `delayMs`, so a burst of keystrokes is one search, for the
// last of them. Dropping a late answer stays with whoever makes the request.

/** `value`, once it has held still for `delayMs`; the first value at once. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
}
